import React from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon, ArrowLeftIcon } from '@heroicons/react/24/outline';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          {/* Logo */}
          <img
            className="mx-auto h-24 w-auto mb-8"
            src="/assets/icons/nazai-studio-logo.png"
            alt="Nazaï Studio Admin"
          />
          
          {/* 404 Error */}
          <div className="mb-8">
            <h1 className="text-9xl font-bold text-primary-600">404</h1>
            <h2 className="text-3xl font-bold text-gray-900 mt-4">Page non trouvée</h2>
            <p className="text-lg text-gray-600 mt-4">
              La page d'administration que vous recherchez n'existe pas ou a été déplacée.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="space-y-4">
            <Link
              to="/"
              className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors duration-200"
            >
              <HomeIcon className="h-5 w-5 mr-2" />
              Tableau de bord
            </Link>
            
            <div className="block">
              <button
                onClick={() => window.history.back()}
                className="inline-flex items-center px-6 py-3 border border-gray-300 text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors duration-200"
              >
                <ArrowLeftIcon className="h-5 w-5 mr-2" />
                Page précédente
              </button>
            </div>
          </div>

          {/* Admin Links */}
          <div className="mt-8 pt-8 border-t border-gray-200">
            <p className="text-sm text-gray-500 mb-4">
              Accès rapide aux sections principales :
            </p>
            <div className="space-y-2">
              <Link
                to="/clients"
                className="block text-sm text-primary-600 hover:text-primary-700"
              >
                Gestion des clients
              </Link>
              <Link
                to="/sessions"
                className="block text-sm text-primary-600 hover:text-primary-700"
              >
                Gestion des séances
              </Link>
              <Link
                to="/bookings"
                className="block text-sm text-primary-600 hover:text-primary-700"
              >
                Gestion des réservations
              </Link>
              <Link
                to="/orders"
                className="block text-sm text-primary-600 hover:text-primary-700"
              >
                Gestion des commandes
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
